import { bootstrapActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export default createReducer(false, {
  [bootstrapActions.success.type]: () => true,
});
